<template>
  <CareDataContent
    :fetch-results
    :status-filter-option="allRequestsStatusOptions"
  >
    <template #title="{ totalCount }">
      <h2 class="text-heading-2">
        {{
          i18n(translations.requestsTotalCount, {
            count: totalCount,
          })
        }}
      </h2>
    </template>

    <template #table="{ data }">
      <AllRequestsTable :requests="data || []" />
    </template>

    <template #empty-state>
      <NoRequestFoundBlock>
        <p class="body-1">
          {{ i18n(translations.noRequestFoundDescription) }}
        </p>
        <RevLink
          to="https://backmarket.my.site.com/ssc/s/article/The-order-page-and-how-it-works"
        >
          <span class="body-1-bold">
            {{ i18n(translations.noRequestFoundLinkLabel) }}
          </span>
        </RevLink>
      </NoRequestFoundBlock>
    </template>
  </CareDataContent>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevLink } from '@ds/components/Link'

import CareDataContent from '../CareDataContent/CareDataContent.vue'
import { EMPTY_FILTERS_VALUES } from '../Filters/Filters.constants'
import filtersTranslations from '../Filters/Filters.translations'
import NoRequestFoundBlock from '../NoRequestFoundBlock/NoRequestFoundBlock.vue'

import translations from './AllRequests.translations'
import AllRequestsTable from './AllRequestsTable/AllRequestsTable.vue'

const i18n = useI18n()
const $httpFetch = useHttpFetch()

const emit = defineEmits(['update-task-count'])

emit('update-task-count')

const allRequestsStatusOptions = computed(() => {
  return [
    {
      label: i18n(filtersTranslations.statusFilterUpcomingOption),
      value: 'UPCOMING',
    },
    {
      label: i18n(filtersTranslations.statusFilterLateOption),
      value: 'LATE',
    },
    {
      label: i18n(filtersTranslations.statusFilterTodoOption),
      value: 'TODO',
    },
    {
      label: i18n(filtersTranslations.statusFilterNoActionNeededOption),
      value: 'NO_ACTION_NEEDED',
    },
    {
      label: i18n(filtersTranslations.statusFilterCompletedOption),
      value: 'COMPLETED',
    },
  ]
})

function fetchResults(query: Partial<typeof EMPTY_FILTERS_VALUES>) {
  return $httpFetch('/seller-after-sales/api/v1/requests', {
    query: { sort: 'UPDATED_AT', ...query },
  })
}
</script>
